<template>
    <v-card>
      <v-card-title>
        <search v-model="search"/>
        <v-dialog persistent v-model="dialog" max-width="80vw">
            <Form v-model="model" @submit="submit($event.value)">
                <template v-slot:header>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog=false" icon text>
                        <v-icon>close</v-icon>
                    </v-btn>
                </template>
                <template v-slot:actions>
                    <v-btn @click="dialog=false">Cancel</v-btn>
                </template>
            </Form>
        </v-dialog>
      </v-card-title>
      <v-data-table
            :items="garageLocations"
            :items-per-page="options.itemsPerPage"
            :headers="headers"
            :search="search"
            :loading="$wait.is(['loading garage locations'])"
            :footer-props.sync="footerProps"
            :options.sync="options"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr @click="userIsFleetManager ? openEdit(props.item) : null">
                    <td>{{props.item.location || "&nbsp;"}}</td>
                    <td>
                        <div v-if="props.item.metricValidationEmails.length == 0"></div>
                        <div
                            v-else-if="props.item.metricValidationEmails.length == 1"
                        >{{props.item.metricValidationEmails[0]}}
                        </div>
                        <div v-else>
                            <v-chip>{{props.item.metricValidationEmails.length}} email recipients</v-chip>
                        </div>
                    </td>
                    <td>
                        <div v-if="props.item.metricValidationCCEmails.length == 0"></div>
                        <div
                            v-else-if="props.item.metricValidationCCEmails.length == 1"
                        >{{props.item.metricValidationCCEmails[0]}}
                        </div>
                        <div v-else>
                            <v-chip>{{props.item.metricValidationCCEmails.length}} cc recipients</v-chip>
                        </div>
                    </td>
                    <td>
                        <div v-if="props.item.escalationEmails.length == 0"></div>
                        <div
                            v-else-if="props.item.escalationEmails.length == 1"
                        >{{props.item.escalationEmails[0]}}
                        </div>
                        <div v-else>
                            <v-chip>{{props.item.escalationEmails.length}} email recipients</v-chip>
                        </div>
                    </td>
                    <td>
                        <div v-if="props.item.escalationCCEmails.length == 0"></div>
                        <div
                            v-else-if="props.item.escalationCCEmails.length == 1"
                        >{{props.item.escalationCCEmails[0]}}
                        </div>
                        <div v-else>
                            <v-chip>{{props.item.escalationCCEmails.length}} cc recipients</v-chip>
                        </div>
                    </td>
                    <td>
                        <span
                            class="mr-1 nobreak"
                            v-for="(calendarUtilisationBand, index) in props.item.calendarUtilisationBands"
                            :key="index"
                        >
                            <v-icon v-if="index != 0">chevron_right</v-icon>
                            {{calendarUtilisationBand}}
                        </span>
                    </td>
                    <td class="garageactions">
                        <v-btn v-if="userIsFleetManager" @click="openEdit(props.item)" icon>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
  import Form from './Form.vue';
  import Search from '../Search.vue';
  import GarageLocations from '../GarageLocations/GarageLocationsClient.vue';

  export default {
    components: {
      Form,
      Search
    },
    mixins: [GarageLocations],
    data() {
      return {
        garageLocations: [],
        dialog: false,
        search: '',
        options: {
          itemsPerPage: 10,
          sortBy: ['displayName']
        },
        footerProps: {
          itemsPerPageOptions: [10, 50, 100]
        },
        headers: [
          {text: 'Location', value: 'location'},
          {text: 'Metric Validation Emails', value: 'adminEmails', sortable: false},
          {text: 'Metric Validation CC Emails', value: 'adminEmails', sortable: false},
          {text: 'Escalation Emails', value: 'adminEmails', sortable: false},
          {text: 'Escalation CC Emails', value: 'adminEmails', sortable: false},
          {text: 'Calendar Preview Bands', value: 'calendarUtilisationBands', sortable: false},
          {text: '', value: 'id', sortable: false}
        ],
        model: {
        }
      };
    },
    methods: {
      openEdit(garage) {
        this.model = {...garage}; // spread operator intentionally used to create clone
        this.dialog = true;
      },
      async loadGarages() {
        this.garageLocations = await this.getGarageLocations(true);
      },
      async submit(value) {
        await this.saveGarageLocation(value);
        await this.loadGarages();
        this.dialog = false;
      }
    },
    async mounted() {
      await this.loadGarages();
    }
  };
</script>

<style>
    td.garageactions {
        text-align: right;
    }

    .nobreak {
        white-space: nowrap;
    }
</style>
